// extracted by mini-css-extract-plugin
export default {"btn_submit":"Button_btn_submit__jouCB"};